class ErrorHandler {
  constructor() {
    this.unexpectedErrorHandler = function(e) {
      setTimeout(() => {
        throw e;
      }, 0);
    };
  }
  setUnexpectedErrorHandler(newUnexpectedErrorHandler) {
    this.unexpectedErrorHandler = newUnexpectedErrorHandler;
  }
  getUnexpectedErrorHandler() {
    return this.unexpectedErrorHandler;
  }
  onUnexpectedError(e) {
    this.unexpectedErrorHandler(e);
  }
  // For external errors, we don't want the listeners to be called
  onUnexpectedExternalError(e) {
    this.unexpectedErrorHandler(e);
  }
}
const errorHandler = new ErrorHandler();
const canceledName = "Canceled";
function isPromiseCanceledError(error) {
  return error instanceof Error && error.name === canceledName && error.message === canceledName;
}
function onUnexpectedError(e) {
  if (!isPromiseCanceledError(e)) {
    errorHandler.onUnexpectedError(e);
  }
  return void 0;
}
export {
  ErrorHandler,
  errorHandler,
  isPromiseCanceledError,
  onUnexpectedError
};
